import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section, SectionHeader } from './ui/Section';
import { faqItems } from '../data/faq';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section tone="sand" className="py-14 sm:py-16 lg:py-20" data-id="element-26" data-mp="1l9o7zc3da5nb">
      <SectionHeader title="Preguntas frecuentes" data-id="element-27" data-mp="1gdqst93ub5c4" />

      <ul className="mx-auto mt-8 max-w-[44rem] space-y-2.5 sm:mt-11" data-id="element-28" data-mp="2e0fxxrtu9y27">
        {faqItems.map((item, index) => {
        const isOpen = openIndex === index;
        return <li key={item.question} className="overflow-hidden rounded-lg border border-oceano/12 bg-white" data-id="element-29" data-mp="291wato3ieg89" data-mpi={index}>
              <h3 data-id="element-30" data-mp="240fem5vyzhy0">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left sm:px-5" data-id="element-31" data-mp="24433usudti6x">
                  <span className="font-sans text-[13px] font-medium leading-snug text-oceano sm:text-[14px]" data-id="element-32" data-mp="nnqqni0q46cy">
                    {item.question}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-caribe transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-33" data-mp="ugr5glu2kghe" />
                </button>
              </h3>
              <div id={`faq-panel-${index}`} hidden={!isOpen} className="border-t border-oceano/10 px-4 py-4 font-sans text-[12.5px] leading-relaxed text-hierro sm:px-5 sm:text-[13px]" data-id="element-34" data-mp="khtk1rrxx32m">
                {item.answer}
              </div>
            </li>;
      })}
      </ul>
    </Section>;
}